import { ActionTypeKeys, ActionTypes } from 'embed/actions'

export const initialParentState = {
  loading: true,
}

const reducer = (state = initialParentState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.LOAD_PARENT_DATA:
      return { ...state, ...action.data, loading: false }
    default:
      return state
  }
}

export default reducer
